import { createContext } from 'react';

export type SalesforceRuntimeConfig = {
    SALESFORCE_ESW_NAME?: string;
    SALESFORCE_ESW_URL?: string;
    SALESFORCE_ORG_ID?: string;
    SALESFORCE_SCRT2_URL?: string;
};

export type RuntimeConfig = {
    AI_SERVER_URL?: string;
    APPLICATION_INSIGHTS_ENABLED?: boolean;
    ELASTIC_APM_ENABLED?: boolean;
    ELASTIC_APM_URL?: string;
    MEMBERS_APPLICATION_INSIGHTS_API_KEY?: string;
    MIXPANEL_API?: string;
    MIXPANEL_ENABLED?: boolean;
    MIXPANEL_TOKEN?: string;
    ONLYOFFICE_SERVER_URL?: string;
    PSPDFKIT_SERVER_URL?: string;
    REACT_QUERY_DEVTOOLS_ENABLED?: boolean;
    REACT_SCAN?: boolean;
    REFETCH_ON_WINDOW_FOCUS?: boolean;
    SECRETARIES_APPLICATION_INSIGHTS_API_KEY?: string;
    SENTRY_DSN?: string;
    SENTRY_ENVIRONMENT?: string;
    SENTRY_ORG?: string;
    SENTRY_PROJECT?: string;
    VERSION?: string;
    WS_SERVER_URL?: string;
} & SalesforceRuntimeConfig;

export const RuntimeContext = createContext<RuntimeConfig | null>(null);
